import CourseNavigationLayout from "@/screens/CourseNavigationLayout.jsx";

export default function AmazonInvestPage() {
  const navItems = [
    {
      path: "/course/amazonInvest/lessons",
      value: "course",
      label: "Курсы",
      onProgress: false,
    },
    {
      path: "/course/amazonInvest/products-list",
      value: "productList",
      label: "Список Товаров",
      onProgress: false,
    },
    {
      path: "/course/amazonInvest/bonus",
      value: "bonusLessons",
      label: "Бонусные видеоуроки",
      onProgress: false,
    },
    {
      path: "/course/amazonInvest/chat",
      value: "chats",
      label: "Чат с наставником",
      onProgress: false,
    },
    {
      path: "/course/amazonInvest/ai",
      value: "ai",
      label: "ИИ чат",
      onProgress: false,
    },
    {
      path: "/course/amazonInvest/invest",
      value: "invest",
      label: "Инвестор",
      onProgress: false,
    },
    {
      path: "/course/amazonInvest/telegram",
      value: "telegram",
      label: "Телеграм канал",
      onProgress: false,
      externalLink: `https://t.me/orlandiya22`,
    },
  ];

  return <CourseNavigationLayout navItems={navItems} />;
}
